<template>
  <div class="p-train-course">
    <section class="c-p-r course-top">
      <div class="c-d-f c-fd-c c-ai-c c-p-c c-ta-c c-c-white cm-width">
        <p class="c-fs-38 c-mb-32 c-fw-b top-title">ZABBIX 中级认证培训课程</p>
        <p class="c-fs-16 c-ff-l c-mb-36 top-desc">适用于专业使用Zabbix的技术人员，5天的系统性培训全面教授Zabbix的概念和架构知识</p>
        <div class="c-d-f c-jc-c c-ff-b c-w-100">
          <button class="c-btn-dark-156 c-btn-trans">已认证工程师</button>
          <button class="c-ml-8 c-btn-156-nob">立即报名</button>
        </div>
      </div>
    </section>
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="c-pt-80 c-pb-80 c-bc-white course-medium">
        <section class="c-d-f cm-width c-m-a">
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-b-r c-pt-24">
            <div class="cm-w-60">
              <img src="../assets/support/support1.png">
              <p class="c-fs-20 c-c-text-blue">理论</p>
              <p class="c-pt-16 c-fs-14 c-lh-22 c-ta-j c-c-text-grey">培训将系统性的教授Zabbix理论知识：从基本术语、Zabbix组件，功能点介绍到分布式监控概览，再到内部协议和高可用设置等。</p>
            </div>
          </div>
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-b-r c-pt-24">
            <div class="cm-w-60">
              <img src="../assets/support/support2.png">
              <p class="c-fs-20 c-c-text-blue">实践</p>
              <p class="c-pt-16 c-fs-14 c-lh-22 c-ta-j c-c-text-grey">培训也包含了大量的实践课程，每个学员都可以自行安装和配置Zabbix，设置监控设备、采集指标，现场解决复杂的监控问题</p>
            </div>
          </div>
          <div class="c-d-f c-fd-c c-ai-c c-f-1 c-ta-c c-pt-24">
            <div class="cm-w-60">
              <img src="../assets/support/support3.png">
              <p class="c-fs-20 c-c-text-blue">问答</p>
              <p class="c-pt-16 c-fs-14 c-lh-22 c-ta-j c-c-text-grey">培训过程设有多个问答环节，参与者可以就实践问题随时咨询培训师，及时得到专业的建议。</p>
            </div>
          </div>
        </section>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="c-pt-32 cm-width course-medium-mobile">
        <div class="c-mb-8 c-bc-white course-medium-item">
          <div class="c-bc-white c-d-f c-pe-none">
            <img src="../assets/support/support1.png">
            <div class="c-ml-24">
              <p class="c-fs-15 c-c-text-blue c-mb-8">理论</p>
              <p class="c-fs-12 c-lh-20 c-ta-j c-c-text-grey">培训将系统性的教授Zabbix理论知识：从基本术语、Zabbix组件，功能点介绍到分布式监控概览，再到内部协议和高可用设置等。</p>
            </div>
          </div>
        </div>
        <div class="c-mb-8 c-bc-white course-medium-item">
          <div class="c-bc-white c-d-f c-pe-none">
            <img src="../assets/support/support2.png">
            <div class="c-ml-24">
              <p class="c-fs-15 c-c-text-blue c-mb-8">实践</p>
              <p class="c-fs-12 c-lh-20 c-ta-j c-c-text-grey">培训也包含了大量的实践课程，每个学员都可以自行安装和配置Zabbix，设置监控设备、采集指标，现场解决复杂的监控问题</p>
            </div>
          </div>
        </div>
        <div class="c-bc-white course-medium-item">
          <div class="c-bc-white c-d-f c-pe-none">
            <img src="../assets/support/support3.png">
            <div class="c-ml-24">
              <p class="c-fs-15 c-c-text-blue c-mb-8">问答</p>
              <p class="c-fs-12 c-lh-20 c-ta-j c-c-text-grey">培训过程设有多个问答环节，参与者可以就实践问题随时咨询培训师，及时得到专业的建议。</p>
            </div>
          </div>
        </div>
      </section>
    </section>
    <section class="c-visible-pc" v-if="$store.state.isPc">
      <section class="cm-width c-m-a c-pb-164 course-introduce">
        <div class="c-d-f c-ai-c c-mt-80 c-mb-40">
          <img src="../assets/index/icon.png">
          <span class="c-ml-12 c-c-text-color c-ff-m c-fs-24">培训课程介绍</span>
        </div>
        <p class="c-mt-40 c-mb-40 c-fs-18">目前Zabbix提供4个标准培训课程，以适应不同级别的用户需求</p>
        <div class="c-d-f c-c-text-grey c-fs-14">
          <div class="c-f-1 c-ta-c c-ta-j c-cs-p course-item" v-for="item in courseList" :key="item.name" @click="$router.push(item.url)">
            <div class="c-pt-32 c-pb-20 c-ta-c c-bc-background-blue-light">
              <p class="c-c-white c-fs-24">{{item.name}}</p>
              <p class="c-fs-18 c-c-orange">{{item.price}}</p>
            </div>
            <div class="c-pt-12 c-pb-12 c-bc-background-blue-dark">
              <p class="c-c-white c-fs-14 c-ta-c">{{item.level}}</p>
            </div>
            <div class="c-lh-26 c-pt-36 c-bc-white course-item-bottom">
              <p class="c-f-1 course-item-top">{{item.description}}</p>
              <div class="c-lh-30 c-f-1 c-pl-20">
                <ul>
                  <li v-for="i in item.infoList" :key="i">{{i}}</li>
                </ul>
                <p v-for="j in item.require" :key="j">{{j}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="c-d-f c-jc-c c-mt-60">
          <button class="c-btn-256">立即成为Zabbix认证工程师</button>
          <button class="c-ml-12 c-btn-dark-198-nob">报名峰会培训享5折</button>
        </div>
      </section>
    </section>
    <section class="c-visible-mobile" v-if="!$store.state.isPc">
      <section class="cm-width c-pb-40 course-introduce-mobile">
        <div class="c-d-f c-ai-c c-mt-40 c-mb-24">
          <img src="../assets/index/icon.png" class="c-icon-mobile">
          <span class="c-ml-12 c-c-text-color c-ff-m c-fs-16">培训课程介绍</span>
        </div>
        <p class="c-mb-24 c-fs-12">目前Zabbix提供4个标准培训课程，以适应不同级别的用户需求</p>
        <div class="c-d-f c-jc-sb c-fw-w c-c-text-grey c-fs-12">
          <div class="c-mb-16 c-ta-c c-ta-j c-cs-p c-bc-white course-item-mobile" v-for="item in courseList" :key="item.name" @click="$router.push(item.url)">
            <div class="c-pt-20 c-pb-12 c-ta-c c-bc-background-blue-light">
              <p class="c-c-white c-fs-16">{{item.name}}</p>
              <p class="c-fs-13 c-c-orange">{{item.price}}</p>
            </div>
            <div class="c-pt-8 c-pb-8 c-bc-background-blue-dark">
              <p class="c-c-white c-fs-12 c-ta-c">{{item.level}}</p>
            </div>
            <div class="c-lh-20 c-pt-20 course-item-bottom">
              <p class="course-item-top">{{item.description}}</p>
              <div class="c-mt-12 c-pl-20 c-pb-20">
                <ul>
                  <li v-for="i in item.infoList" :key="i">{{i}}</li>
                </ul>
                <p v-for="j in item.require" :key="j">{{j}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="c-d-f c-jc-c c-ai-c c-mt-24 mobile-btns">
          <button class="c-plr-20 c-btn-198">立即成为Zabbix认证工程师</button>
          <button class="c-ml-12 c-btn-dark-198-nob btn-special">报名峰会培训享5折</button>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
const courseList = [
  {
    url: '/train_zcu',
    name: 'ZCU',
    price: '¥ 2,500/1天',
    level: 'Zabbix初级认证',
    description: '适用学习Zabbix的基本使用，了解Zabbix的功能，使用Zabbix前端查看和监控管理信息。',
    infoList: ['版本：5.0', '授课方式：在线/现场', '参与要求：'],
    require: ['无']
  },
  {
    url: '/train_zcs',
    name: 'ZCS',
    price: '¥ 19,500/5天',
    level: 'Zabbix中级认证',
    description: '适合专业使用Zabbix的技术人员，5天的系统培训全面教授Zabbix的概念和构架知识，技术人员无障碍、高效率的使用Zabbix，为大中小型企业客户提供支持。',
    infoList: ['版本：5.0', '授课方式：现场', '参与要求：'],
    require: ['了解基本计算机操作', '了解主流操作系统']
  },
  {
    url: '/train_zcp',
    name: 'ZCP',
    price: '¥ 16,500/3天',
    level: 'Zabbix高级认证',
    description: '大规模复杂环境，如网络应用监控中Zabbix分布式监控的部署，Zabbix，agent，proxy的使用，以及更多关于相关的高级主题。',
    infoList: ['版本：5.0', '授课方式：现场', '参与要求：'],
    require: ['参加ZCS考试并通过获取ZCS证书']
  },
  {
    url: '/train_zce',
    name: 'ZCE',
    price: '¥ 32,500/5天',
    level: 'Zabbix专家级认证',
    description: '教授API，HA/DR，数据库分区方面的专业知识，为企业高级技术管理人员设计和维护高效率高负载的监控环境提供知识支撑。',
    infoList: ['版本：5.0', '授课方式：现场', '参与要求：'],
    require: ['参加ZCP考试并通过获取ZCP证书']
  }
]
export default {
  name: 'course',
  data () {
    return {
      courseList: courseList
    }
  }
}
</script>

<style lang="scss">
.p-train-course {
  min-height: calc(100vh - 90px - 525px);
  .cm-w-60 {
    width: 60%;
  }
  .course-top {
    height: 560px;
    @media screen and (max-width: $max-width-standard) {
      height: 232px;
      background: url("../assets/support/support-banner-m.jpg") no-repeat;
      background-size: cover;
      background-position: center;
      .top-title {
        font-size: 19px;
        margin-bottom: 12px;
      }
      .top-desc {
        width: 70%;
        font-size: 9px;
        line-height: 16px;
        margin-bottom: 15px!important;
      }
    }
    background: url("../assets/support/support-banner.jpg") no-repeat;
    background-size: cover;
    background-position: center;
  }
  .course-medium-mobile {
    .course-medium-item {
      padding: 25px 16px;
      padding-right: 24px;
      img {
        width: 73.5px;
        height: 73.5px;
        object-fit: contain;
      }
    }
  }
  .course-introduce {
    .course-item {
      margin-left: 20px;
      border-bottom: 4px solid #44DBE7;
      &:hover {
        box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
      }
      .course-item-bottom {
        min-height: 412px;
        padding-left: 22px;
        padding-right: 22px;
        .course-item-top {
          min-height: 180px;
        }
      }
    }
    & .course-item:nth-of-type(1) {
      margin-left: 0;
    }
    & .course-item:nth-of-type(2) {
      border-bottom-color: $orange;
    }
    & .course-item:nth-of-type(3) {
      border-bottom-color: #7696FE;
    }
    & .course-item:nth-of-type(4) {
      border-bottom-color: #FFE653;;
    }
  }
  .course-introduce-mobile {
    .course-item-mobile {
      width: calc(100%/2 - 5px);
      border-bottom: 3px solid #44DBE7;
      box-shadow: 0 8px 34px 0 rgba(0, 31, 255, 0.05);
      .course-item-bottom {
        padding-left: 16px;
        padding-right: 16px;
        .course-item-top {
          line-height: 18px;
          height: 128px;
          overflow: scroll;
          @media screen and (min-width: 480px){
            height: 92px;
          }
        }
      }
    }
    & .course-item-mobile:nth-of-type(2) {
      border-bottom-color: $orange;
    }
    & .course-item-mobile:nth-of-type(3) {
      border-bottom-color: #7696FE;
    }
    & .course-item-mobile:nth-of-type(4) {
      border-bottom-color: #FFE653;;
    }
    .mobile-btns {
      @media screen and (max-width: 350px) {
        flex-direction: column;
        .btn-special {
          margin-left: 0;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
